import { OBJECTIVES_ICON_LABEL, SUB_OBJECTIVES } from 'omega-rtc/constants/ucd';
import _ from 'lodash';
import React from 'react';

const UCDObjectiveLabel = ({ objective, subObjective, iconSize = 48, fontSize = 18, fontWeight = 700 }) => {
  const iconSrc =
    objective && _.get(OBJECTIVES_ICON_LABEL, `${objective}.icon`, '');
  const iconLabel =
    objective && _.get(OBJECTIVES_ICON_LABEL, `${objective}.label`, objective);
  const getStyleForLabel = () => {
    return {
      marginLeft: 8,
      fontFamily: 'Roboto',
      fontSize,
      fontWeight,
      display: 'flex',
      alignItems: 'center',
    };
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      {iconSrc ? <img src={iconSrc} alt={objective} style={{ width: iconSize }} /> : ''}
      <div style={getStyleForLabel()}>
        {iconLabel} { subObjective && <span> : {_.get(_.get(SUB_OBJECTIVES, subObjective), 'label')} </span> }
      </div>
    </div>
  );
};

export default UCDObjectiveLabel;
